import React, {useCallback, useEffect, useState} from 'react';
import styles from "./LandingInfo.module.scss";
import {Button, Input, Modal, Notify, Select, useToast} from "uikit";
import ArrowIcon from "@/assets/images/icons/12/arrow.svg";
import PencilIcon from "@/assets/images/icons/16/pencil.svg";
import CopyIcon from "@/assets/images/icons/16/copy.svg";
import LinkIcon from '@/assets/images/icons/16/link.svg';
import {LandingInfoSchema} from "@/views/Admin/Events/Event/General/Info/Section/LandingInfo/LandingInfo.schema";
import {useTranslation} from "react-i18next";
import {LandingInfoPropsInterface} from "./LandingInfo.props.interface";
import {LandingInfoMethods} from "./LandingInfo.methods";
import {useParams} from "react-router-dom";

const LandingInfo = ({data, onChange}: LandingInfoPropsInterface) => {
    const [content, setContent] = useState(LandingInfoSchema);
    const {t} = useTranslation('common');
    const params: { id: any } = useParams();
    const addToast = useToast();

    const {updateEventSlug, checkUrlSlug, changeEventUrl, generateSlug} = LandingInfoMethods;

    const afishaDomain = {
        0: 'в Событиях',
        1: <div onClick={() => {
            handleGenerateSlug(data.fields.title.value)
            setContent(prev => ({...prev, isChangeUrlModal: true}))
        }}>в Афише</div>
    };

    useEffect(() => {
        handleCheckDomain();
    }, []);

    const handleCheckDomain = () => {
        if (data.landingUrl.includes('afisha') || data.landingUrl.includes('afisha')) {
            setContent(prev => ({...prev, domainAfisha: 1}));
        } else if (data.landingUrl.includes('localhost') || data.landingUrl.includes('events') || data.landingUrl.includes('academy')) {
            setContent(prev => ({...prev, domainAfisha: 0}));
        } else {
            setContent(prev => ({...prev, domainAfisha: 2}));
        }
    }

    const debounce = (func, delay) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), delay);
        };
    };


    const handleCopyUrl = async (text) => {
        await navigator.clipboard.writeText(text);
        setContent(prev => ({...prev, copyUrlText: `${t('copied')}`}));

        setTimeout(() => {
            setContent(prev => ({...prev, copyUrlText: `${t('copy')}`}));
        }, 3000)
    }

    const handleGenerateSlug = async (value) => {
        if (value.length < 2) {
            setContent(prev => ({...prev, newSlug: null}));
            return;
        }

        try {
            let body = {'event_title': `${value}`};
            let response = await generateSlug(body);
            if ([200, 201].includes(response.status)) {
                setContent(prev => ({...prev, newSlug: response.data}));
                await handleCheckSlugUrl(response.data.slug);
            }
        } catch (err) {
            console.log(err)
        }
    }

    const debouncedGenerateUrl = useCallback(debounce(handleGenerateSlug, 500), [content.newSlug]);

    const handleChangeSlug = async (e) => {
        const regex = /^[a-z0-9]+(?:-[a-z0-9]+)*$/i;
        setContent(prev => ({...prev, generateSlugInput: {...prev.generateSlugInput, value: e.target.value, error: null, isDisabled: false}}))

        if (regex.test(e.target.value)) {
            setContent(prev => ({...prev, generateSlugInput: {...prev.generateSlugInput, error: null, isDisabled: false}}))
            debouncedGenerateUrl(e.target.value)
        } else {
            setContent(prev => ({...prev, generateSlugInput: {...prev.generateSlugInput, error: 'В адресе можно использовать латинские буквы, цифры и знак "-"', isDisabled: true}}))
        }
    }

    const handleRenameSlug = async (slugId, slug) => {
        try {
            let response = await updateEventSlug(slugId, slug);
            if (response) {
                addToast({
                    message: 'Адрес изменен',
                    type: 'success',
                    duration: 3000,
                });
                onChange()
                setContent(prev => ({...prev, isEditSlug: false}))
            }
        } catch ({response}) {
            addToast({
                message: 'Не удалось изменить адрес, попробуйте снова',
                type: 'danger',
                duration: 3000,
            });
        }
    }

    const handleCheckSlugUrl = async (slug) => {
        try {
            let body = {'slug': slug}
            await checkUrlSlug(body, params.id)
        } catch (err) {
            console.log(err)
        }
    }

    const handleChangeEventUrl = async () => {
        try {
            let response = await changeEventUrl(content.newSlug.slug, params.id, data.eventType)
            if (response) {
                onChange()
                setContent(prev => ({...prev, isChangeUrlModal: false, domainAfisha: 1}))
            }
        } catch (err) {
            console.log(err)
        }
    }

    return (
        <div className={styles.container}>
            <div className={styles.address}>
                <small>
                    Адрес
                </small>
                {content.domainAfisha === 1 ?
                    <p className={styles.addresText}>в Афише</p> : null
                }
                {content.domainAfisha === 0 ? <Select
                    size={'small'}
                    direction={['bottom', 'center']}
                    value={content.domainAfisha}
                    data={afishaDomain}
                    onChange={(e) => setContent(prev => ({...prev, domainAfisha: e}))}>
                    <div className={styles.dropdown}>
                        <div className={styles.dropdownValue}>{afishaDomain[`${content.domainAfisha}`]}</div>
                        <ArrowIcon/>
                    </div>
                </Select> : null}

            </div>
            <div className={styles.link}>
                <div className={styles.url}>
                    <p>
                        {data.landingUrl}
                    </p>
                    {content.domainAfisha === 1 ?
                        <Button
                            size={'small'}
                            theme={'default'}
                            type={'secondary'}
                            onClick={() => setContent(prev => ({
                                ...prev,
                                isEditSlug: true,
                                generateSlugInput: {...prev.generateSlugInput, value: data.eventSlug.slug ? data.eventSlug.slug : ''}
                            }))}>
                            <PencilIcon/>
                        </Button> : null
                    }
                </div>
                <div className={styles.btns}>
                    <Button
                        size={'small'}
                        theme={'default'}
                        type={'secondary'}
                        onClick={() => handleCopyUrl(data.landingUrl)}>
                        <CopyIcon/>
                        {content.copyUrlText}
                    </Button>
                    <a href={'/admin/attach_domain/'}>
                        <Button
                            size={'small'}
                            theme={'default'}
                            type={'events'}
                            onClick={(e) => console.log(e)}>
                            {t('link_domain')}
                        </Button>
                    </a>
                </div>
            </div>
            {/*Modal change url*/}
            <Modal
                style={{padding: '16px', paddingLeft: '64px', maxWidth: '600px', width: '100%'}}
                className={styles.modal}
                active={content.isChangeUrlModal}
                onActive={(e: boolean) => setContent(prev => ({...prev, isChangeUrlModal: e, domainAfisha: 0}))}
                onMissClick={(event) => console.log(event)}
                onEscape={(event) => console.log(event)}
            >
                <div>
                    <h6 className={styles.modalTitle}>Новый адрес {data.eventType === 'courses' ? 'курса' : 'события'} в Афише Nethouse</h6>
                </div>
                <div className={styles.warning}>
                    <Notify type={'warning'}>
                        Вы переносите страницу вашего {data.eventType === 'courses' ? 'курса' : 'события'} на <span>домен Афиши</span>. Прежний адрес, ссылки на него, а также обратный перенос более не будут доступны.
                    </Notify>
                </div>
                <div className={styles.modalLogo}>
                    <LinkIcon/>
                </div>
                <p className={styles.modalText}>
                    Новый адрес: <br/>
                    <span>https://afisha.nethouse.ru/{data.eventType === 'events' ? 'event' : 'course'}/{content.newSlug && content.newSlug.slug || 'moe-krutoe-sobitie'}</span>
                </p>
                <div className={styles.modalControl}>
                    <Button
                        size={'small'}
                        theme={'ghost'}
                        type={'tertiary'}
                        onClick={() => setContent(prev => ({...prev, isChangeUrlModal: false, domainAfisha: 0}))}
                    >
                        <span>Отмена</span>
                    </Button>
                    <Button
                        size={'small'}
                        theme={'default'}
                        type={'primary'}
                        onClick={() => {
                            handleChangeEventUrl()
                        }}
                    >
                        <span>Перенести</span>
                    </Button>
                </div>
            </Modal>
            {/*Modal change slug*/}
            {data.eventSlug ?
                <Modal
                    style={{padding: '16px', paddingLeft: '64px', maxWidth: '600px', width: '100%'}}
                    className={styles.modal}
                    active={content.isEditSlug}
                    onActive={(e: boolean) => setContent(prev => ({...prev, isEditSlug: e}))}
                    onMissClick={(event) => console.log(event)}
                    onEscape={(event) => console.log(event)}
                >
                    <div>
                        <h6 className={styles.modalTitle}>Новый адрес события</h6>
                    </div>
                    <div className={styles.modalLogo}>
                        <LinkIcon/>
                    </div>
                    <div className={styles.modalInput}>
                        <Input
                            size={'medium'}
                            label={'Адрес'}
                            error={content.generateSlugInput.error && content.generateSlugInput.value !== '' ? content.generateSlugInput.error : null}
                            value={content.generateSlugInput.value ? String(content.generateSlugInput.value) : ''}
                            onChange={(e) => handleChangeSlug(e)}
                        />
                    </div>
                    <p>
                        Адрес полностью:<br/>
                        <span>https://afisha.nethouse.ru/{data.eventType === 'events' ? 'event' : 'course'}/{(String(content.generateSlugInput.value).length > 1 && content.newSlug) ? content.newSlug.slug : data.eventSlug.slug}</span>
                    </p>
                    <div className={styles.modalControl}>
                        <Button
                            size={'small'}
                            theme={'ghost'}
                            type={'tertiary'}
                            onClick={() => setContent(prev => ({...prev,
                                isEditSlug: false,
                                generateSlugInput: {...prev.generateSlugInput, value: null, error: null, isDisabled: false},
                                newSlug: {...data.eventSlug}
                            }))}
                        >
                            <span>Отмена</span>
                        </Button>
                        <Button
                            size={'small'}
                            theme={'default'}
                            type={'primary'}
                            disabled={content.generateSlugInput.isDisabled || Boolean(content.generateSlugInput.value === '')}
                            onClick={() => handleRenameSlug(data.eventSlug.id, content.newSlug ? content.newSlug.slug : null)}
                        >
                            <span>Сохранить</span>
                        </Button>
                    </div>
                </Modal> : null
            }
        </div>
    );
};

export default LandingInfo;
